<template>
  <font-awesome-icon
    icon="file-csv"
    size="lg"
    class="icon"
    @click.stop="showExport()"/>
</template>


<script>
export default {
  props: {
    event: {
      required: true,
      type: Object
    }
  },

  methods: {
    showExport: function () {
      this.$router.push({
        name: 'event-closed-export',
        params: { id: this.event.id}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_icon.scss';
</style>

